import { UpdateMealRequest } from "@/clients/models/UpdateMealRequest";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

export const useUpdatePlanMeal = () => {
  const paramsRef = useRef<UpdateMealRequest | null>(null);
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isPending, error } = useMutation<
    Record<string, unknown>,
    Error,
    UpdateMealRequest
  >({
    mutationKey: [QueryKeys.PLAN_MEAL],
    mutationFn: async (params: UpdateMealRequest) => {
      const user = guardGetUserFromLocalStorage();
      paramsRef.current = params;
      const { data } = await PlansService.updateMealInPlanApiV1PlansMealPut(user.id, {
        day: params.day,
        mealTime: params.mealTime,
        mealIndex: params.mealIndex ?? undefined,
        currentMealId: params.currentMealId ?? undefined,
        meal_id: params.meal_id,
        meal_name: params.meal_name,
        requestId: params.requestId,
        selectedPosition: params.selectedPosition ?? undefined,
        targetDate: params.targetDate ?? undefined,
        isExtra: params.isExtra ?? undefined,
      });
      console.log("=== result from update plan meal ===", data);
      const daily = data?.nutrition?.daily;
      console.log("=== daily from update plan meal ===", daily);
      const dailyTarget = Object.entries(daily ?? {}).map(([index, value]) => {
        return {
          index,
          calories: value.calories,
          calories_diviation: value.calories_deviation,
          calories_target: value.calories_target,
        };
      });
      console.table(dailyTarget);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.PLAN],
      });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.BALANCE_CALORIES],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.BALANCE_PROTEIN],
      });
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.SHOPPING_LIST],
      });
    },
    onSettled: () => {
      paramsRef.current = null;
    },
  });

  return {
    updateMeal: mutate,
    updateMealAsync: mutateAsync,
    isLoading: isPending,
    error,
  };
};
